export default function formatReportYearAndQuarter(report) {
  return `${report.reportYear} (Q${report.reportQuarterCode})`
}
